import React from "react";
import { observer } from "mobx-react";
import { EsignatureConfigUpdateStore } from "../../store";
import { EsignatureConfigUpdateForm } from "./EsignatureConfigUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";
import { EsignatureProvider } from "../../../../api/graphql";

export type EsignatureConfigUpdateProps = {
  esignatureConfigUpdateStore: EsignatureConfigUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const EsignatureConfigUpdate: React.FC<EsignatureConfigUpdateProps> =
  observer(
    ({ esignatureConfigUpdateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={esignatureConfigUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={esignatureConfigUpdateStore.savedButOutdated}
            onReload={() =>
              esignatureConfigUpdateStore.reloadEsignatureConfig()
            }
            reloadDisabled={esignatureConfigUpdateStore.isProcessing}
          />
          <EsignatureConfigUpdateForm
            esignatureConfigUpdateStore={esignatureConfigUpdateStore}
            providerError={esignatureConfigUpdateStore.errors.provider?.message}
            providerOptions={esignatureConfigUpdateStore.getProviderOptions()}
            onProviderChange={(value: EsignatureProvider) => {
              esignatureConfigUpdateStore.setProviderValue(value);
            }}
            provider={esignatureConfigUpdateStore.entityValues.provider}
            credentialsError={
              esignatureConfigUpdateStore.errors.credentials?.message
            }
            onCredentialsChange={(value: string) => {
              esignatureConfigUpdateStore.setCredentialsValue(value);
            }}
            credentials={esignatureConfigUpdateStore.entityValues.credentials}
            sandboxModeError={
              esignatureConfigUpdateStore.errors.sandboxMode?.message
            }
            onSandboxModeChange={(value: boolean) => {
              esignatureConfigUpdateStore.setSandboxModeValue(value);
            }}
            sandboxMode={esignatureConfigUpdateStore.entityValues.sandboxMode}
            webhookSecretError={
              esignatureConfigUpdateStore.errors.webhookSecret?.message
            }
            onWebhookSecretChange={(value: string) => {
              esignatureConfigUpdateStore.setWebhookSecretValue(value);
            }}
            webhookSecret={
              esignatureConfigUpdateStore.entityValues.webhookSecret
            }
            enabledError={esignatureConfigUpdateStore.errors.enabled?.message}
            onEnabledChange={(value: boolean) => {
              esignatureConfigUpdateStore.setEnabledValue(value);
            }}
            enabled={esignatureConfigUpdateStore.entityValues.enabled}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={esignatureConfigUpdateStore.saveDisabled}
            onSave={() => esignatureConfigUpdateStore.saveEsignatureConfig()}
            onCancel={() =>
              esignatureConfigUpdateStore.cancelEsignatureConfig()
            }
          />
          <ErrorDialog
            open={esignatureConfigUpdateStore.errorDialogOpened}
            title={esignatureConfigUpdateStore.errorTitle}
            description={esignatureConfigUpdateStore.errorDescription}
            onClose={() => esignatureConfigUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={esignatureConfigUpdateStore.confirmDialogOpened}
            title={esignatureConfigUpdateStore.confirmDialogTitle}
            description={esignatureConfigUpdateStore.confirmDialogDescription}
            onConfirm={() =>
              esignatureConfigUpdateStore.executeConfirmedAction()
            }
            onCancel={() => esignatureConfigUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
